import { I18nMessages } from '../../i18n/messages';

const useI18nMessages = () => I18nMessages;

export default useI18nMessages;
